export function IconMessageQuestion({ className }: Readonly<{ className?: string }>) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M14.167 15.35H10.833L7.108 17.833C6.558 18.2 5.833 17.808 5.833 17.142V15.35C3.333 15.35 1.667 13.683 1.667 11.183V6.183C1.667 3.683 3.333 2.017 5.833 2.017H14.167C16.667 2.017 18.333 3.683 18.333 6.183V11.183C18.333 13.683 16.667 15.35 14.167 15.35Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 9.467V9.292C10 8.717 10.358 8.408 10.717 8.167C11.067 7.933 11.417 7.625 11.417 7.067C11.417 6.283 10.783 5.65 10 5.65C9.217 5.65 8.583 6.283 8.583 7.067"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.996 11.458H10.005"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
